"use strict";

import {ACTION_NAMES, EVENTS, SOURCES, VALUES_PROPERTIES} from './FlexTrackerConstants'

const BrowserEventTracker = require('../BrowserEventTracker');

module.exports = (FlexApiRequest = window.FlexApiRequest) => {

    class FlexTracker extends BrowserEventTracker {
        constructor() {
            //call reaction to track
            super((metric, source, values) => {
                var request = {
                    metric,
                    source,
                    ...values
                };

                FlexApiRequest.POST(
                    { path: '/api/v1/marketplaceactivity/trackevent' }
                ).send(request);
            });
        }

        track(eventName, values) {
            if (eventName !== ACTION_NAMES.VDP_VIEW)
                return;

            const listingId = values[VALUES_PROPERTIES.LISTING_ID];
            const vehicleId = values[VALUES_PROPERTIES.VEHICLE_ID];

            super.track(
                EVENTS.VIEW,
                SOURCES.VDP,
                {
                    listingId,
                    vehicleId
                }
            );

        }
    }

    return FlexTracker;
};